import * as React from 'react';

export const AsFileUpload = ({
  isDisabled = false,
  multiple = false,
  accept,
  onFiles,
  children,
}: {
  isDisabled?: boolean;
  multiple?: boolean;
  accept?: string;
  onFiles: (files: File[]) => void;
  children: React.ReactNode;
}) => {
  let inputRef: HTMLInputElement | null;
  const handleOnClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.preventDefault();
    inputRef?.click();
  };

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!event.target.files) {
      return;
    }
    return onFiles(Array.from(event.target.files));
  };

  return (
    <>
      <span onClick={isDisabled ? undefined : handleOnClick}>{children}</span>
      <input
        data-testid="asfileupload-input"
        ref={ref => {
          inputRef = ref;
        }}
        style={{ display: 'none' }}
        type="file"
        name="file"
        multiple={multiple}
        accept={accept}
        onChange={onChange}
      />
    </>
  );
};
